import { render, staticRenderFns } from "./ProfitAndLossFilter.vue?vue&type=template&id=5270efe1&scoped=true&lang=pug&"
import script from "./ProfitAndLossFilter.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLossFilter.vue?vue&type=style&index=0&id=5270efe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270efe1",
  null
  
)

/* custom blocks */
import block0 from "./ProfitAndLossFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDivider,VListItemContent,VListItemTitle,VSelect,VSpacer})
